(function () {
document.addEventListener("DOMContentLoaded", function() {
    var _loop = function(i) {
        var subnav = subnavs[i];
        var subnavItems = subnav.querySelectorAll(".layout-subnav__link");
        window.addEventListener("scroll", function() {
            var subnavBounding = subnav.getBoundingClientRect();
            var header = document.getElementById("header");
            var subnavNav = subnav.querySelector("nav");
            checkSubnavLocations(subnav, subnavItems, subnavNav.offsetHeight + 202);
            if (subnavBounding.top <= header.clientHeight) {
                if (!subnav.classList.contains("layout-subnav--fixed")) subnav.classList.add("layout-subnav--fixed");
                if (!header.classList.contains("header--subnav")) header.classList.add("header--subnav");
            } else if (subnav.classList.contains("layout-subnav--fixed")) {
                subnav.classList.remove("layout-subnav--fixed");
                if (header.classList.contains("header--subnav")) header.classList.remove("header--subnav");
            }
        });
    };
    // Variables
    var subnavs = document.querySelectorAll(".layout-subnav");
    function checkSubnavLocations(subnav, subnavItems, subnavOffset) {
        var foundSection = false;
        for(var o = subnavItems.length - 1; o >= 0; o--){
            var subnavItem = subnavItems[o];
            var link = subnavItem.querySelector("a");
            var href = link.getAttribute("href");
            var regex = RegExp("(?<=#)\\w*", "gm");
            var m = void 0;
            while((m = regex.exec(href)) !== null){
                if (m.index === regex.lastIndex) regex.lastIndex++;
                m.forEach(function(match) {
                    var section = document.getElementById(match);
                    if (section) {
                        var sectionBounding = section.getBoundingClientRect();
                        if (sectionBounding.top <= subnavOffset && foundSection == false) {
                            foundSection = true;
                            if (!subnavItem.classList.contains("layout-subnav__link--active")) subnavItem.classList.add("layout-subnav__link--active");
                            if (o == subnavItems.length - 1 && sectionBounding.bottom <= 120) subnav.classList.add("layout-subnav__hidden");
                            else if (subnav.classList.contains("layout-subnav__hidden")) subnav.classList.remove("layout-subnav__hidden");
                        } else subnavItem.classList.remove("layout-subnav__link--active");
                    }
                });
            }
        }
    }
    for(var i = 0; i < subnavs.length; i++)_loop(i);
});

})();
//# sourceMappingURL=layout-subnav.js.map
